import React, { useEffect } from "react";
import { setResponsiveImage } from "../../helpers";
import "./index.scss";
import ShareButton, { ShareBtnProps } from "../ShareButton/src";

interface Props {
  subheading?: string;
  heading?: string;
  brandLogo?: string;
  sponsorLogo?: string;
  sponsorLink?: string;
  mobileImage?: string;
  tabletImage?: string;
  desktopImage?: string;
  invert?: boolean;
  shareBtn?: ShareBtnProps | null;
  isBeach?: boolean;
  isResults?: boolean;
  tourCode?: string;
}

const GenericHero = ({
  heading = "Heading goes here",
  subheading,
  brandLogo,
  sponsorLogo,
  tourCode,
  sponsorLink,
  mobileImage,
  tabletImage,
  desktopImage,
  shareBtn = null,
  invert,
  isBeach,
  isResults
}: Props) => {
  useEffect(() => {
    setResponsiveImage({
      mobileImage,
      tabletImage,
      desktopImage,
      elClassName: "generic-hero"
    });
  }, []);

  return (
    <div
      className={`generic-hero${invert ? " invert" : ""}${
        isBeach ? " beach" : ""
      }${isResults ? " results" : ""}`}
    >
      <div className="container">
        {brandLogo && tourCode !== "WCT" ? (
          <div className="generic-hero__brand-logo">
            <img src={brandLogo} alt={heading} />
          </div>
        ) : tourCode == "WCT" && sponsorLogo && sponsorLink ? (
          <a
            target="_blank"
            href={sponsorLink}
            className="generic-hero__brand-logo"
          >
            <img src={sponsorLogo} alt={heading} />
          </a>
        ) : null}
        <h1>
          {subheading ? <small>{subheading}</small> : null}
          <strong>{heading}</strong>
        </h1>
        <div className="generic-hero__share">
          <ShareButton
            isRightAligned
            socialMedia={shareBtn != null ? shareBtn.socialMedia : {}}
          />
        </div>
      </div>
      {sponsorLogo && sponsorLink && tourCode !== "WCT" ? (
        <a
          target="_blank"
          href={sponsorLink}
          className="generic-hero__sponsor-logo"
        >
          <img src={sponsorLogo} alt={heading} />
        </a>
      ) : tourCode == "WCT" && brandLogo ? (
        <div className="generic-hero__sponsor-logo">
          <img src={brandLogo} alt={heading} />
        </div>
      ) : null}
    </div>
  );
};

export default GenericHero;
